import { Link, useLocation } from "react-router-dom";
import JanteLogo from "@/components/JanteLogo";
import { ArrowRight } from "lucide-react";

export default function Header() {
  const location = useLocation();
  const onApplyPage = location.pathname.startsWith("/onboard");

  return (
    <header
      data-testid="site-header"
      className="w-full border-b border-[#E3DED5] bg-[#FAF9F6]/85 backdrop-blur-sm sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between gap-6">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-3 group shrink-0"
        >
          <JanteLogo size={44} />
          <span className="flex flex-col leading-tight">
            <span className="font-serif-display text-xl lg:text-2xl font-medium text-[#2A1F1A] tracking-tight">
              Sasha <span className="text-[#B0895C]">by</span> Janté Lux Hotels and Residences
            </span>
            <span
              data-testid="brand-tagline"
              className="font-script text-[#C03028] text-xl lg:text-2xl"
              style={{ fontFamily: "'Monotype Corsiva', 'Italianno', 'Cormorant Garamond', cursive" }}
            >
              Vacation With The Mission In Mind
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          <Link
            to="/#service-levels"
            data-testid="nav-jante-way"
            className="text-sm text-[#6E6E70] hover:text-[#2A1F1A] transition-colors"
          >
            Host The Janté Way
          </Link>
          <a
            href="https://jantetcsasha.com/tenant-thrive"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-jante-thrive"
            className="text-sm text-[#6E6E70] hover:text-[#2A1F1A] transition-colors"
          >
            Janté Thrive
          </a>
          <Link
            to="/investing"
            data-testid="nav-investing"
            className="text-sm text-[#6E6E70] hover:text-[#2A1F1A] transition-colors"
          >
            Investing with 1000
          </Link>
          <Link
            to="/your-sasha"
            data-testid="nav-your-sasha"
            className="text-sm text-[#C03028] hover:text-[#9F2620] font-medium transition-colors"
          >
            Your Sasha
          </Link>
          <Link
            to="/portal"
            data-testid="nav-hosts-portal"
            className="text-sm text-[#6E6E70] hover:text-[#2A1F1A] transition-colors"
          >
            Host&apos;s Portal
          </Link>
        </nav>

        {!onApplyPage ? (
          <Link
            to="/onboard"
            data-testid="header-cta-apply"
            className="btn-primary inline-flex items-center gap-2 px-5 py-2.5 text-sm tracking-wide rounded-none"
          >
            Apply now
            <ArrowRight size={14} />
          </Link>
        ) : (
          <Link
            to="/"
            data-testid="header-back-home"
            className="text-sm text-[#6E6E70] hover:text-[#2A1F1A] transition-colors"
          >
            ← Back home
          </Link>
        )}
      </div>
    </header>
  );
}
